import axios from 'axios'
import {API_URL} from '../constants';

const ERROR_REPORT_API_URL = `${API_URL}/errorReports`;

class ErrorReportService {
    fetchErrorReportBy(page, pageSize, fromDate, toDate, worker, errorGroup, errorDetails, reporter) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${ERROR_REPORT_API_URL}/by`,  {page: page, pageSize: pageSize, fromDate: fromDate, toDate: toDate, worker: worker, errorGroup: errorGroup, errorDetails: errorDetails, reporter},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    exportToExcel(page, pageSize, fromDate, toDate, worker, errorGroup, errorDetails, reporter){
        const token = sessionStorage.getItem('token');       
        return axios.post(`${ERROR_REPORT_API_URL}/errorReportToExcel`,  {page: page, pageSize: pageSize, fromDate: fromDate, toDate: toDate, worker: worker, errorGroup: errorGroup, errorDetails: errorDetails, reporter},
            { 
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob' 
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }
}

export default new ErrorReportService();
